import { useState } from "react";
import Dropdown from "./Dropdown";
import Link from "next/link";

export function PricingSectionPriceDetail({
  title,
  price,
  priceNote,
  priceOther,
  description,
  buttonLabel,
  onButtonClick,
  buttonHref,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  secondaryButtonHref,
  footer,
  prices,
}) {
  const [selectedPrice, setSelectedPrice] = useState(
    prices ? prices[0] : { price, priceNote }
  );

  return (
    <div className="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12 lg:w-sm">
      <p className="text-lg leading-6 font-medium text-gray-900">{title}</p>
      {priceOther ? (
        <div className="mt-4 flex items-center justify-center text-xl font-medium text-gray-500">
          {priceOther}
        </div>
      ) : (
        <div className="mt-4 flex items-center justify-center text-5xl leading-none font-extrabold text-gray-900 -mx-6">
          <span className="whitespace-no-wrap">{selectedPrice.price}</span>
          <span className="ml-3 text-xl leading-7 font-medium text-gray-500">
            {prices ? (
              <Dropdown
                value={selectedPrice.priceNote}
                options={prices.map((p) => p.priceNote)}
                onChange={(e) =>
                  setSelectedPrice(
                    prices.find((p) => p.priceNote === e.target.value)
                  )
                }
              />
            ) : (
              priceNote
            )}
          </span>
        </div>
      )}
      <p className="mt-4 text-sm leading-5">{description}</p>
      {buttonLabel ? (
        <div className="mt-6">
          <div className="rounded-md shadow">
            <Link href={buttonHref || "#"}>
              <a
                onClick={
                  onButtonClick
                    ? (e) => {
                        e.preventDefault();
                        onButtonClick();
                      }
                    : undefined
                }
                className="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
              >
                {buttonLabel}
              </a>
            </Link>
          </div>
        </div>
      ) : null}
      {secondaryButtonLabel ? (
        <div className="mt-3">
          <div className="rounded-md shadow">
            <Link href={secondaryButtonHref || "#"}>
              <a
                href="#"
                onClick={
                  onSecondaryButtonClick
                    ? (e) => {
                        e.preventDefault();
                        onSecondaryButtonClick();
                      }
                    : undefined
                }
                className="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
              >
                {secondaryButtonLabel}
              </a>
            </Link>
          </div>
        </div>
      ) : null}

      {footer ? (
        <div className="mt-4 text-sm leading-5 font-medium text-gray-900">
          {footer}
        </div>
      ) : null}
    </div>
  );
}

export function PricingSection({
  title,
  description,
  includedItems,
  priceDetail,
  additionalDescription,
}) {
  return (
    <div className="mt-8 sm:mt-12">
      <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex">
          <div className="flex-1 bg-white px-6 py-8 lg:flex-shrink-1 lg:p-12">
            <h3 className="text-2xl leading-8 font-extrabold text-gray-900 sm:text-3xl sm:leading-9">
              {title}
            </h3>
            <p className="mt-6 text-base leading-6 text-gray-500">
              {description}
            </p>
            {includedItems?.length ? (
              <div className="mt-8">
                <div className="flex items-center">
                  <h4 className="flex-shrink-0 pr-4 bg-white text-sm leading-5 tracking-wider font-semibold uppercase text-red-600">
                    What's included
                  </h4>
                  <div className="flex-1 border-t-2 border-gray-200"></div>
                </div>
                <ul className="mt-8 lg:grid lg:grid-cols-2 lg:col-gap-8 lg:row-gap-5">
                  {includedItems.map((content) => {
                    return (
                      <li className="flex items-start lg:col-span-1">
                        <div className="flex-shrink-0">
                          <svg
                            className="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p className="ml-3 text-sm leading-5 text-gray-700">
                          {content}
                        </p>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : null}
            {additionalDescription ? (
              <p className="mt-6 text-base leading-6 text-gray-500">
                {additionalDescription}
              </p>
            ) : null}
          </div>
          {priceDetail}
        </div>
      </div>
    </div>
  );
}
